module.exports = __webpack_public_path__ + "img/menu-min.5fc38d6f.svg";